import { Dispatch } from 'redux';
import {
    cssStylingPaymentIframe,
    IApiReturnObject,
    ICssStylingPaymentIframeRequest, ICssStylingPaymentIframeResponse, IMediaRule, sendUpdateMediaMatchAction
} from '@bold-commerce/checkout-frontend-library';
import { getPigiIframe, getPigiStylingRules, handleErrorIfNeeded } from 'src/utils';
import { IOrderInitialization } from 'src/types';

export async function postCssStylingPigi(dispatch: Dispatch, getState: () => IOrderInitialization): Promise<void> {
    const rules: ICssStylingPaymentIframeRequest = getPigiStylingRules();
    console.log({ rules })
    rules.css_rules?.push({ "cssText": ".TogglePanelGroup { border: none;}" },
        { cssText: '.TogglePanel__Content { padding: 0; border: none;}' },
        { cssText: '.Field--RememberCardToggle {display: none;}' },
        { cssText: '.Field.Field--WithToggleField.Field--is-checked.TogglePanel__Field { display: none;}' },
        { cssText: '.TogglePanel__Header { display: none;}' }
    );
    console.log({ rules })
    const promiseResponse = cssStylingPaymentIframe(rules);
    return promiseResponse.then(async (res: IApiReturnObject) => {
        handleErrorIfNeeded(res, dispatch, getState);
        if (res.success) {
            const pigiIframe = getPigiIframe();
            pigiIframe?.addEventListener('load', () => {
                const { data: { style_sheet: { mediaRules } } } = res.response as { data: ICssStylingPaymentIframeResponse };
                if (mediaRules && Array.isArray(mediaRules)) {
                    mediaRules.forEach((rule: IMediaRule) => {
                        const mediaMatch = window.matchMedia(rule.conditionText);
                        if (mediaMatch) {
                            mediaMatch.addEventListener('change', (event: MediaQueryListEvent) => sendUpdateMediaMatchAction(event.media, event.matches));
                            sendUpdateMediaMatchAction(mediaMatch.media, mediaMatch.matches);
                        }
                    });
                }
            });
        }
    });
}
